/**
 * @generated SignedSource<<720074a13e87844d415b7b91962f9183>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStepDeliveryView_item$data = {
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "CheckoutReviewStepDeliveryView_item";
};
export type CheckoutReviewStepDeliveryView_item$key = {
  readonly " $data"?: CheckoutReviewStepDeliveryView_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStepDeliveryView_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStepDeliveryView_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "11a3a7d4e9a6a961181f10654ad7848d";

export default node;
